import { QuickPoll } from 'src/domain/quick-poll';

export const isPollClosed = (poll: QuickPoll, currentDate?: Date | string): boolean =>
  new Date(poll.closingAt) <= (currentDate ? new Date(currentDate) : new Date());
